export const FILE_URLS_UPDATE = 'FILE_URLS_UPDATE';
export const FILE_URLS_UPDATE_REQUEST = 'FILE_URLS_UPDATE_REQUEST';

export const FILE_ATTACHMENTS_URLS_SYNCED = 'FILE_ATTACHMENTS_URLS_SYNCED';

export const USER_FILES_DELETED = 'USER_FILES_DELETED';
